import { cn } from "@/lib/utils";

/**
 * Statut d'une ACTION CORRECTIVE.
 *
 * Quatre valeurs, dont `inefficace` — qui n'existe pas sur les litiges et n'a
 * pas vocation à y apparaître : il qualifie ici le résultat d'un traitement,
 * pas l'avancement d'un dossier.
 *
 * À ne pas confondre avec `verification_status`, l'axe distinct de la
 * vérification d'efficacité ISO, qui porte lui aussi une valeur `inefficace`.
 */
const STYLES = {
  ouverte: "bg-blue-50 text-blue-800 border-blue-200",
  en_cours: "bg-amber-50 text-amber-800 border-amber-200",
  cloturee: "bg-slate-100 text-slate-600 border-slate-200",
  inefficace: "bg-rose-50 text-rose-700 border-rose-200",
};

const LIBELLES = {
  ouverte: "Ouverte",
  en_cours: "En cours",
  cloturee: "Clôturée",
  inefficace: "Inefficace",
};

export default function ActionStatusBadge({ status, className, testId }) {
  const style = STYLES[status] || STYLES.ouverte;
  const libelle = LIBELLES[status] || status;
  return (
    <span
      data-testid={testId || `action-status-badge-${status}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border",
        style,
        className,
      )}
    >
      {libelle}
    </span>
  );
}
